import * as React from 'react';
import { useMemo } from 'react';

import { useModalContext } from 'common/contexts';
import type { SecurityEventAPIType, SecurityEventEntity } from 'security-app/hooks/api/securityEventsAPI.types';
import EventDetails from 'security-app/components/SecurityEvents/Alerts/EventDetails';
import useNonDisplayedAttributes from 'components/events/events/hooks/useNonDisplayedAttributes';
import type { DefaultLayout } from 'components/common/EntityDataTable/types';

type Props = {
  securityEvent: SecurityEventEntity;
  defaultLayout: DefaultLayout;
};

function ExpandedEventDetails({ securityEvent, defaultLayout }: Props) {
  const { setEntity, setModal } = useModalContext();

  const securityEventAPIType: SecurityEventAPIType = useMemo(() => {
    const {
      event_id,
      status,
      opened_at,
      closed_at,
      updated_at,
      owner,
      notes,
      associated_investigations,
      recorded_metrics,
      is_security_event,
      part_of_detection_chain,
      ...event
    } = securityEvent;

    return {
      event_id,
      status,
      opened_at,
      closed_at,
      updated_at,
      owner,
      notes,
      associated_investigations,
      recorded_metrics,
      is_security_event,
      part_of_detection_chain,
      event,
    };
  }, [securityEvent]);

  const onReplaySearch = React.useCallback(() => {
    setEntity(securityEventAPIType);
    setModal('REPLAY-SEARCH-VIEW');
  }, [securityEventAPIType, setEntity, setModal]);

  const nonDisplayedAttributes = useNonDisplayedAttributes(defaultLayout);

  return (
    <EventDetails
      securityEventId={securityEvent.event_id}
      onReplaySearch={onReplaySearch}
      detailsAttributes={nonDisplayedAttributes}
    />
  );
}

export default ExpandedEventDetails;
